import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageShell, { Section } from "@/components/site/PageShell";
import { Note, Prose } from "@/components/site/ui";
import { CATEGORIES, ENTRIES } from "@/content/changelog";

const formatDate = iso => new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function Changelog() {
  const [filter, setFilter] = useState(null);
  const entries = filter ? ENTRIES.filter(e => e.categories.includes(filter)) : ENTRIES;

  return (
    <PageShell eyebrow="Nouveautés" title="Ce que nous avons livré."
      lead="Chaque entrée correspond à du code réellement déployé en production."
      actions={<Link to="/roadmap" className="button button-outline">Voir ce qui arrive<ArrowRight size={13} /></Link>}>
      <Section>
        <div className="pill-row">
          <button type="button" className={`pill${!filter ? " is-ok" : ""}`} onClick={() => setFilter(null)} data-testid="changelog-all">Tout</button>
          {Object.entries(CATEGORIES).map(([key, c]) => (
            <button key={key} type="button" className={`pill${filter === key ? " is-ok" : ""}`} onClick={() => setFilter(key)} data-testid={`changelog-${key}`}>{c.label}</button>
          ))}
        </div>
      </Section>

      <Section>
        <div className="changelog">
          {entries.map((e, i) => (
            <article key={i} className="changelog-entry">
              <div className="changelog-date"><time dateTime={e.date}>{formatDate(e.date)}</time></div>
              <div className="changelog-body">
                <div className="changelog-tags">
                  {e.categories.map(c => <span key={c} className={`tag tag-${CATEGORIES[c].tone}`}>{CATEGORIES[c].label}</span>)}
                </div>
                <h3>{e.title}</h3>
                <p>{e.summary}</p>
                <ul>{e.points.map(p => <li key={p}>{p}</li>)}</ul>
              </div>
            </article>
          ))}
        </div>
      </Section>

      <Section title="Suivre les nouveautés">
        <Note kind="info">
          Nous n'avons pas encore de liste de diffusion ni de flux RSS pour les nouveautés.
          En attendant, cette page est la source de vérité, et la <Link to="/roadmap">feuille de route</Link> annonce la suite.
        </Note>
      </Section>

      <Section>
        <Prose><p>Un changement incompatible sur l'API serait annoncé ici au moins 30 jours à l'avance.</p></Prose>
      </Section>
    </PageShell>
  );
}
